exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trainer__body[data-v-5804005e]{flex-direction:row;justify-content:center;align-items:flex-start}.columns__item[data-v-5804005e],.trainer__body[data-v-5804005e]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.columns__item[data-v-5804005e]{flex-direction:column;max-width:400px;transition:none;height:100%}.columns__item.single[data-v-5804005e],.teacher__menu[data-v-5804005e]{width:100%}@media (max-width:640px){.trainer__body[data-v-5804005e]{flex-wrap:wrap}}", ""]);

// exports
